import { Redirect } from 'app/routx-router'

function Me() {
  return <Redirect to={'profile'} replace />
}

export const Component = Me
export default Me
